<template>
    <div class="teacher_info">
        <div class="teacher_text">讲师照片</div>
        <el-image class="course_img2" :src="imgPath('course_img2.png')"></el-image>
        <div class="teacher_text">讲师简介</div>
        <div>
            中共党员，泰国玛希隆大学公共卫生博士，昆明医科大学公共卫生学院副教授，硕士研究生导师。主持校级教研教改课题1项，参与2项，指导中共党员，泰国玛希隆大学公共卫生博士，昆明医科大学公共卫生学院副教授，硕士研究生导师。主持校级教研教改课题1项，参与2项，指导中共党员，泰国玛希隆大学公共卫生博士，昆明医科大学公共卫生学院副教授，硕士研究生导师。主持校级教研教改课题1项，参与2项，指导中共党员，泰国玛希隆大学公共卫生博士，昆明医科大学公共卫生学院副教授，硕士研究生导师。主持校级教研教改课题1项，参与2项，指导中共党员，泰国玛希隆大学公共卫生博士，昆明医科大学公共卫生学院副教授，硕士研究生导师。主持校级教研教改课题1项，参与2项，指导中共党员，泰国玛希隆大学公共卫生博士，昆明医科大学公共卫生学院副教授，硕士研究生导师。主持校级教研教改课题1项，参与2项，指导中共党员，泰国玛希隆大学公共卫生博士，昆明医科大学公共卫生学院副教授，硕士研究生导师。主持校级教研教改课题1项，参与2项，指导中共党员，泰国玛希隆大学公共卫生博士，昆明医科大学公共卫生学院副教授，硕士研究生导师。主持校级教研教改课题1项，参与2项，指导中共党员，泰国玛希隆大学公共卫生博士，昆明医科大学公共卫生学院副教授，硕士研究生导师。主持校级教研教改课题1项，参与2项，指导中共党员，泰国玛希隆大学公共卫生博士，昆明医科大学公共卫生学院副教授，硕士研究生导师。主持校级教研教改课题1项，参与2项，指导
        </div>
    </div>
</template>

<script>
export default {
    name: 'GjkcH5TeacherInfo',

    data() {
        return {

        };
    },

    mounted() {

    },

    methods: {

    },
};
</script>
<style lang="scss" scoped>
.teacher_info {
    max-height: 550px;
    .teacher_text {
        margin: 15px 0;
        color: #333333;
        font-weight: 600;
    }

    .course_img2 {
        width: 150px;
        height: 182px;
        border-radius: 10px;
    }
}
</style>